import { render, staticRenderFns } from "./DialogDocumentKeyword.vue?vue&type=template&id=08698c45&scoped=true"
import script from "./DialogDocumentKeyword.vue?vue&type=script&lang=js"
export * from "./DialogDocumentKeyword.vue?vue&type=script&lang=js"
import style0 from "./DialogDocumentKeyword.vue?vue&type=style&index=0&id=08698c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08698c45",
  null
  
)

export default component.exports